/**
 * RunProgressBar — live progress for a docai_runs row.
 * Renders phase + done/total, indeterminate while queued/no counts.
 */
import React from 'react';
import { Box, HStack, Progress, Text } from '@chakra-ui/react';
import StatusChip from './StatusChip';

export default function RunProgressBar({ run }) {
  if (!run) return null;
  const progress = run.progress || {};
  const total = Number(progress.total) || 0;
  const done = Number(progress.done) || 0;
  const pct = total ? Math.min(100, Math.round((done / total) * 100)) : null;
  const active = run.status === 'running' || run.status === 'queued';

  return (
    <Box w="100%">
      <HStack justify="space-between" mb={1}>
        <HStack spacing={2}>
          <StatusChip status={run.status} />
          <Text fontSize="xs" color="gray.500">
            {run.kind}
            {progress.phase ? ` — ${progress.phase}` : ''}
          </Text>
        </HStack>
        <Text fontSize="xs" color="gray.500">
          {total ? `${done}/${total}` : ''}
        </Text>
      </HStack>
      <Progress
        size="sm"
        borderRadius="md"
        value={pct ?? undefined}
        isIndeterminate={active && pct === null}
        colorScheme={run.status === 'error' ? 'red' : run.status === 'done' ? 'green' : 'blue'}
      />
      {run.error && (
        <Text fontSize="xs" color="red.400" mt={1} noOfLines={2}>
          {run.error}
        </Text>
      )}
    </Box>
  );
}
